import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerBg, logo, logoTitle, mobileLogo, viewMenu } from 'images'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/8GFwb8UTNOQ2rbtqc9kk/locations/Y7GXtSFgqD6z5v9Jpd8q'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView column center w="100%" bg="#000000" pv="10px">
          <CFImage
            mt="6px"
            w="75%"
            src={mobileLogo}
            alt="Baik Mi Dang Sushi Logo"
          />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          column
          w="100%"
          bg="rgba(0,0,0,.85)"
          boxShadow="1px 1px 3px rgba(0,0,0,.6)"
          zIndex={98}
          pv="16px"
        >
          <CFImage
            ml="6%"
            w="100%"
            maxWidth="520px"
            src={logo}
            alt="Baik Mi Dang Sushi Logo"
            zIndex={98}
          />
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
